import { Injectable, inject } from '@angular/core'
import { Router, UrlTree } from '@angular/router'

import { Observable, map } from 'rxjs'

import { InstallOptions } from './auth.types'
import { FX_ENVIRONMENT_DEFINITION } from './environment-definition.constants'

@Injectable()
export class OnPremInstallGuard {
  readonly #environmentDefinition = inject(FX_ENVIRONMENT_DEFINITION)
  readonly #router = inject(Router)

  canActivate(): Observable<boolean | UrlTree> {
    return this.#environmentDefinition.pipe(
      map((env) =>
        env.installation === InstallOptions.ON_PREM ? true : this.#router.createUrlTree(['/403'])
      )
    )
  }
}
